import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EndorsementService } from '../service/endorsement/endorsement.service';
import { LabelValueType } from '../global/shared/data-type/label-value';
import { BrancesOfBankType } from '../global/shared/data-type/brances-of-bank';
import * as brancsOfBankJSON from '../global/shared/data-json/smbci_branch_code.json';
import { DownloadDocumentService } from '../service/download-document/download-document.service';
import { EndorsementNonFinancialRequestModel } from '../service/model/endorsement.model';

@Component({
  selector: 'app-endorse-branch-office',
  templateUrl: './endorse-branch-office.component.html',
  styleUrls: ['./endorse-branch-office.component.css']
})
export class EndorseBranchOfficeComponent {
  dataDashboard: any = {}
  login: any = {}
  formEndorse: FormGroup
  isLoading: boolean = false;
  branchList: Array<LabelValueType> = [];
  branchAreaList: Array<BrancesOfBankType> = brancsOfBankJSON["default"];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private endorsementService: EndorsementService,
    private documentService: DownloadDocumentService
  ) {
    let background = document.getElementById("background");
    if (background != null) {
      background.className = "allianz-background-faded"
    }

    let jsonLogin = sessionStorage.getItem("login")
    if (jsonLogin) {
      this.login = JSON.parse(jsonLogin);
    }

    let jsonDataDashboard = localStorage.getItem("selected-item")
    if (jsonDataDashboard) {
      this.dataDashboard = JSON.parse(jsonDataDashboard);
    }

    this.formEndorse = this.formBuilder.group({
      kantorCabang: ['', Validators.required],
      areaKantorCabang: ['', Validators.required],
    })

    localStorage.setItem("endorse-branch", "true")
  }

  onSelectionBranchAreaChange(event: Event) {
    const selectedOption = (event.target as HTMLSelectElement).value;
    const branchListFiltered: Array<BrancesOfBankType> = this.branchAreaList.filter(data => data.region === selectedOption);
    if (branchListFiltered.length > 0) {
      this.branchList = branchListFiltered[0].brances || [];
    }
  }

  continue() {
    if (this.formEndorse.valid) {
      this.isLoading = true;

      const value = this.formEndorse.controls['kantorCabang'].value;
      const lastDashIndex = value.lastIndexOf('-');
      const branchOffice = value.substring(0, lastDashIndex).trim();
      const branchCode = value.substring(lastDashIndex + 1).trim();

      const endorsementRequest: EndorsementNonFinancialRequestModel = {
        productCode: this.dataDashboard.productCode,
        referenceNo: this.dataDashboard.referenceNo,
        branchOfficeChangeRequest: branchOffice,
        branchCodeChangeRequest: branchCode
      }

      this.endorsementService.endorsementNonFinancial(endorsementRequest).subscribe(res => {
        localStorage.setItem("endorsement-response", JSON.stringify(res))
        if (res.statusId == "1") {
          this.documentService.generateLetterBtpn({
            "refnum": this.dataDashboard.referenceNo,
            "memberstatus": "APPROVED"
          }).subscribe(res => {
            this.isLoading = false;
            this.router.navigate(['eform/dashboard/endorse-final'])
          })
        } else {
          this.isLoading = false;
          this.router.navigate(['eform/dashboard/endorse-final'])
        }
      })
    }
  }

  back() {
    this.router.navigate([
      '/eform/dashboard/insured-summary/' +
      this.dataDashboard.referenceNo +
      '/' +
      this.login.partnerId,
    ]);
  }
}
